import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  getInitFormData,
  getNoSlip,
  getTablebySql,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global, withMenuLoading } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showPopupModal } from "@widgets/CommonModal";
import SN_TRA_IBL_REG_003_POP_01 from "@menu/TRA/SN_TRA_IBL_REG_003/SN_TRA_IBL_REG_003_POP_01";
import SN_TRA_IBL_REG_003_POP_02 from "@menu/TRA/SN_TRA_IBL_REG_003/SN_TRA_IBL_REG_003_POP_02";
import SN_TRA_IBL_REG_003_POP_03 from "@menu/TRA/SN_TRA_IBL_REG_003/SN_TRA_IBL_REG_003_POP_03";
import { dateToString } from "@shared/utils/DateUtils";
import SnResizeBar from "@shared/components/SnResizeBar";

interface Props {
  Menuprops: menuInfo;
}

// 부대비용등록
const SN_TRA_IBL_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({ grid1: [], grid2: [] });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops,
          etcInfo: {},
        });

        const popup_apply1 = [
          { target: "cd_cust_pay", source: "cd_cust" },
          { target: "nm_cust_pay", source: "nm_cust" },
        ];
        const grid2 = rtn.grid.grid2.map((col: any) => {
          let newCol = { ...col };
          if (col.cd_column === "cd_cust" || col.cd_column === "cd_cust_pay") {
            newCol.popup_apply = popup_apply1;
          }
          return newCol;
        });

        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({ grid1: rtn.grid.grid1, grid2 });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async (overrideParams?: any) => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirmCancel",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      } else if (confirm === undefined) {
        return;
      }
    }

    const selectedFormData = overrideParams ?? searchRef.current.getFormdata();
    if (selectedFormData.dt_from > selectedFormData.dt_to) {
      showDialog(
        "alter",
        " 조회기간의 종료일이 시작일보다 빠릅니다.\n확인 후 다시 조회해주시기 바랍니다."
      );
      return;
    }

    try {
      const params = {
        id: "sn_tra_ibl_reg_003_01",
        params: overrideParams ?? searchRef.current.getFormdata(),
      };

      setDataSources({ grid1: [], grid2: [] });

      const data: any = await fnGetDataSet(params);
      setDataSources({ grid1: data[0] || [], grid2: data[1] || [] });

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    if ((Menuprops.figure as string) === "fg_drilldown.Registration") {
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
      if (
        modifiedRowsH.modifiedRowcount > 0 ||
        modifiedRowsL.modifiedRowcount > 0
      ) {
        const confirm = await showDialog(
          "confirmCancel",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved = await onSave();
          if (!isSaved) return;
        } else if (confirm !== false) {
          return;
        }
      }
      gridRefs.current["grid1"].current.deleteAllRows();
      gridRefs.current["grid2"].current.deleteAllRows();
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const fgMap = nodeData.fg_map;
      if (fgMap) setFormData((prev: any) => ({ ...prev, fg_map: fgMap }));
      await withMenuLoading(Menuprops.cd_menu ?? "SN_TRA_IBL_REG_003", () =>
        setDrilldown(nodeData.no_docu, nodeData.fg_map)
      );
      return;
    } else if ((Menuprops.figure as string) === "fg_drilldown.Search") {
      const isResolved = nodeData.no_io_chase !== undefined;
      const searchData = {
        ...formData,
        dt_from: nodeData.dt_from ?? formData.dt_from,
        dt_to: nodeData.dt_to ?? formData.dt_to,
        fg_map: (isResolved ? nodeData.fg_prq : nodeData.fg_map) || "002",
        ...(nodeData.cd_biz ? { cd_biz: nodeData.cd_biz } : {}),
        ...(!isResolved && nodeData.cd_cust
          ? { cd_cust: nodeData.cd_cust, nm_cust: nodeData.nm_cust ?? "" }
          : {}),
      };
      setFormData(searchData);
      await withMenuLoading(Menuprops.cd_menu ?? "SN_TRA_IBL_REG_003", () =>
        onSearch(searchData)
      );
    }
  };

  const setDrilldown = async (noDocu: string, fgMap: string) => {
    const [data] = await Promise.all([
      fnGetDataSet({
        id: "sn_tra_ibl_reg_003_drilldown_01",
        params: { cd_firm: userInfo.cd_firm, no_docu: noDocu, fg_map: fgMap },
      }),
      gridRefs.current["grid1"].current?.whenColumnsReady?.(),
      gridRefs.current["grid2"].current?.whenColumnsReady?.(),
    ]);
    const header = data?.[0]?.[0];
    if (!header) {
      await showDialog("alter", "원인 문서를 찾을 수 없습니다.");
      return;
    }
    const addedNode = gridRefs.current["grid1"].current.addRow({});
    if (!addedNode) return;
    for (const key in header) {
      if (
        header[key] !== null &&
        header[key] !== undefined &&
        header[key] !== ""
      ) {
        addedNode.setDataValue(key, header[key]);
      }
    }
    gridRefs.current["grid2"].current.applyFilters({
      no_expense: header.no_expense,
    });
  };

  useEffect(() => {
    const fig = (Menuprops as any).figure as string;
    const nodeData = (Menuprops as any).nodeData;
    if (!formData || columns.grid1.length === 0 || !fig || !nodeData) return;
    onActivate(nodeData);
  }, [columns, Menuprops]);

  const onInsert = async () => {
    try {
      const newRow = {};
      gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onDelete = async () => {
    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) {
      return;
    }

    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }
    await onSave();
  };

  const onAddRow = () => {
    try {
      return gridRefs.current["grid2"].current?.addRow();
    } catch (error: any) {}
  };

  const onDeleteRow = async () => {
    const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }

    gridRefs.current["grid2"].current?.deleteSelectedRows();
    gridRefs.current["grid2"].current?.refreshFooter();
  };

  const onBeforeAddRowH = () => {
    try {
      const traExpensehChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (traExpensehChanges.length > 0) return false;

      const searchInfo = searchRef.current.getFormdata();
      const today = dateToString(new Date());
      return {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        no_expense: "",
        fg_map: searchInfo.fg_map ?? "001",
        dt_expense: today,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        no_docu: "",
        cd_gp: "",
        cd_exch: "",
        cd_bank: "",
        yn_docu: "N",
        cd_cust: "",
      };
    } catch (error: any) {
      return false;
    }
  };

  const onBeforeAddRowL = () => {
    try {
      const selectedRows =
        gridRefs.current["grid1"].current?.getSelectedRows() ?? [];
      if (selectedRows.length === 0) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      const maxNoLine =
        gridRefs.current["grid2"].current?.getMaxValue("no_line");
      return {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        no_line: maxNoLine + 1,
        no_expense: selectedRows[0]?.no_expense,
        cd_expense: "",
        nm_expense: "",
        cd_cust: selectedRows[0]?.cd_cust,
        nm_cust: selectedRows[0]?.nm_cust,
        cd_cust_pay: selectedRows[0]?.cd_cust,
        nm_cust_pay: selectedRows[0]?.nm_cust,
        fg_vat: "21",
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_dist: 0,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onSave = async (): Promise<boolean> => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();

      await new Promise((resolve) => setTimeout(resolve, 0));

      if (!gridRefs.current["grid1"].current.requiredValuesCheck())
        return false;
      if (!gridRefs.current["grid2"].current.requiredValuesCheck())
        return false;

      const traExpensehChanges = gridRefs.current["grid1"].current.getChange();
      const traExpenselChanges = gridRefs.current["grid2"].current.getChange();

      const headerInserts = traExpensehChanges.insert ?? [];
      const lineInserts = traExpenselChanges.insert ?? [];
      if (
        traExpensehChanges.modifiedRowcount === 0 &&
        traExpenselChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog(
          "alter",
          "상세 정보가 없습니다.\n행추가하여 상세정보 작성 후 저장해 주시기 바랍니다."
        );
        return false;
      }

      for (let row of headerInserts) {
        if (row.no_expense) continue;
        const no_slip = await getNoSlip(
          Menuprops.cd_module as any,
          10,
          "TRA",
          row.dt_expense,
          Menuprops.cd_menu as any
        );
        if (!no_slip) {
          await showDialog("alter", "전표번호를 생성할 수 없습니다.");
          return false;
        }
        row.no_expense = no_slip;
        gridRefs.current["grid1"].current
          .focusedRowNode()
          ?.setDataValue("no_expense", no_slip);
        for (let line of lineInserts) {
          if (!line.no_expense) line.no_expense = no_slip;
        }
        gridRefs.current["grid2"].current.applyFilters({ no_expense: no_slip });
      }

      const ok = await fnSave("SN_TRA_IBL_REG_003_SAVE_01", {
        tra_expenseh: traExpensehChanges,
        tra_expensel: traExpenselChanges,
      });
      if (!ok) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        gridRefs.current["grid2"].current.resetUpdate(true);
        return false;
      }

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      showDialog("error", error?.message ?? "저장 중 오류가 발생했습니다.");
      return false;
    }
  };

  // GridV2 는 getFocusedCell 을 노출하지 않으므로, 어떤 컬럼을 눌렀는지 알아야 하는 이 동작은
  // 행 더블클릭이 아니라 셀 더블클릭 이벤트로 받는다(params 에 column/rowIndex 가 들어 있다).
  const onCellDoubleClick = async (event: any) => {
    const rowData = event.data;
    const fgMap = rowData?.fg_map;
    const selectedFormData = searchRef.current.getFormdata();
    const selectedData = { cd_biz: selectedFormData.cd_biz };

    const colId = event?.column?.getColId?.() ?? event?.colDef?.field;
    const focusedRowIndex = event?.rowIndex;
    const grid2Changes = gridRefs.current["grid1"].current.getChange().insert;

    if (grid2Changes.length === 0 || colId !== "no_expense") {
      return;
    }

    if (fgMap === "001") {
      const component = (
        <SN_TRA_IBL_REG_003_POP_01 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "LC조회",
        children: component,
      });
      if (!result || result === "close") return;

      let index = 0;
      const lineResult = result[0];

      for (const item of lineResult) {
        const rowCount =
          gridRefs.current["grid1"].current.getDisplayedRowCount();
        const lastRowIndex = rowCount - 1;
        const lastRowNode =
          gridRefs.current["grid1"].current.getRowNodeAtIndex(focusedRowIndex);
        gridRefs.current["grid1"].current.clearFocus();
        if (index === 0 && lastRowNode) {
          updateRowValues1(lastRowNode, item);
        } else {
          onAddRow();
          const newLastRowNode = gridRefs.current[
            "grid1"
          ].current.getRowNodeAtIndex(lastRowIndex + 1);
          if (newLastRowNode) {
            updateRowValues1(newLastRowNode, item);
          }
        }
        index++;
      }
    } else if (fgMap === "002") {
      const component = (
        <SN_TRA_IBL_REG_003_POP_02 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "BL조회",
        children: component,
      });
      if (!result || result === "close") return;

      let index = 0;
      const lineResult = result[0];

      for (const item of lineResult) {
        const rowCount =
          gridRefs.current["grid1"].current.getDisplayedRowCount();
        const lastRowIndex = rowCount - 1;
        const lastRowNode =
          gridRefs.current["grid1"].current.getRowNodeAtIndex(focusedRowIndex);
        gridRefs.current["grid1"].current.clearFocus();
        if (index === 0 && lastRowNode) {
          updateRowValues2(lastRowNode, item);
        } else {
          onAddRow();
          const newLastRowNode = gridRefs.current[
            "grid1"
          ].current.getRowNodeAtIndex(lastRowIndex + 1);
          if (newLastRowNode) {
            updateRowValues2(newLastRowNode, item);
          }
        }
        index++;
      }
    } else if (fgMap === "003") {
      const component = (
        <SN_TRA_IBL_REG_003_POP_03 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "통관조회",
        children: component,
      });
      if (!result || result === "close") return;

      let index = 0;
      const lineResult = result[0];

      for (const item of lineResult) {
        const rowCount =
          gridRefs.current["grid1"].current.getDisplayedRowCount();
        const lastRowIndex = rowCount - 1;
        const lastRowNode =
          gridRefs.current["grid1"].current.getRowNodeAtIndex(focusedRowIndex);
        gridRefs.current["grid1"].current.clearFocus();
        if (index === 0 && lastRowNode) {
          updateRowValues3(lastRowNode, item);
        } else {
          onAddRow();
          const newLastRowNode = gridRefs.current[
            "grid1"
          ].current.getRowNodeAtIndex(lastRowIndex + 1);
          if (newLastRowNode) {
            updateRowValues3(newLastRowNode, item);
          }
        }
        index++;
      }
    }

    gridRefs.current["grid1"].current.selectAndFocusRow(focusedRowIndex);
  };

  const updateRowValues1 = (rowNode: any, item: any) => {
    rowNode.setDataValue("no_expense", item.no_lc);
    rowNode.setDataValue("no_lc", item.no_lc);
    rowNode.setDataValue("no_src", item.no_lc);
    rowNode.setDataValue("nm_cust", item.nm_cust);
    rowNode.setDataValue("cd_cust", item.cd_cust);
    rowNode.setDataValue("cd_exch", item.cd_exch);
    rowNode.setDataValue("cd_bank", item.cd_bank);
    rowNode.setDataValue("cd_gp", item.cd_gp);
    rowNode.setDataValue("cd_emp", item.cd_emp);
    rowNode.setDataValue("cd_dept", item.cd_dept);
    rowNode.setDataValue("dc_rmk", item.dc_rmk);
  };

  const updateRowValues2 = (rowNode: any, item: any) => {
    rowNode.setDataValue("no_expense", item.no_req);
    rowNode.setDataValue("no_req", item.no_req);
    rowNode.setDataValue("no_src", item.no_req);
    rowNode.setDataValue("nm_cust", item.nm_cust);
    rowNode.setDataValue("cd_cust", item.cd_cust);
    rowNode.setDataValue("cd_exch", item.cd_exch);
    rowNode.setDataValue("cd_gp", item.cd_gp);
    rowNode.setDataValue("cd_emp", item.cd_emp);
    rowNode.setDataValue("cd_dept", item.cd_dept);
    rowNode.setDataValue("dc_rmk", item.dc_rmk);
  };

  const updateRowValues3 = (rowNode: any, item: any) => {
    rowNode.setDataValue("no_expense", item.no_ip);
    rowNode.setDataValue("no_ip", item.no_ip);
    rowNode.setDataValue("no_src", item.no_ip);
    rowNode.setDataValue("nm_cust", item.nm_cust);
    rowNode.setDataValue("cd_cust", item.cd_cust);
    rowNode.setDataValue("cd_exch", item.cd_exch);
    rowNode.setDataValue("cd_gp", item.cd_gp);
    rowNode.setDataValue("cd_emp", item.cd_emp);
    rowNode.setDataValue("cd_dept", item.cd_dept);
    rowNode.setDataValue("dc_rmk", item.dc_rmk);
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      const no_expense = selectedRow.no_expense;
      gridRefs.current["grid2"].current.applyFilters({
        no_expense: no_expense,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  const onCellValueChangedL = async (event: any) => {
    const colId = event?.colId;
    const rowData = event.rowData;
    const rowNode = event?.rowNode;
    const data = event?.rowData;

    try {
      switch (colId) {
        case "cd_cust": {
          rowNode.setDataValue("cd_cust_pay", rowData.cd_cust);
          rowNode.setDataValue("nm_cust_pay", rowData.nm_cust);
          break;
        }
        case "cd_expense": {
          const sqlQuery = {
            sql: "select nm_flag from mas_codel where cd_firm = :cd_firm and cd_clas = 'TRA008' and cd_flag = :cd_flag",
            cd_firm: userInfo.cd_firm,
            cd_flag: data.cd_expense,
          };
          const nm_expense = await getTablebySql(sqlQuery);
          if (nm_expense) {
            rowNode.setDataValue("nm_expense", nm_expense[0].nm_flag);
          }
          break;
        }

        case "fg_vat":
        case "am_k": {
          if (Number(data.am_dist) !== 0) break; // 미착정산된 라인은 부가세 재계산 안 함
          const fgVat = data.fg_vat || "";
          const amK = parseFloat(data.am_k) || 0;
          let rtVat = 10;
          if (fgVat !== "") {
            const sqlQuery = {
              sql: "select coalesce(dc_ref::numeric, 10) as dc_ref from mas_codel where cd_firm = :cd_firm and (cd_clas = 'SYS013' or cd_clas = 'SYS014') and cd_flag = :cd_flag limit 1",
              cd_firm: userInfo.cd_firm,
              cd_flag: data.fg_vat,
            };
            const result = await getTablebySql(sqlQuery);
            rtVat = parseFloat(result[0].dc_ref) || 10;
          }

          const amVat = (amK * rtVat) / 100;
          rowNode.setDataValue("am_vat", amVat);
          break;
        }
      }
    } catch (error) {}
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={columns.grid1}
            rowData={dataSources.grid1}
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              title: "부대비용",
            }}
            events={{
              onFocusedRowChanged: onFocusedRowChanged,
              onBeforeAddRow: onBeforeAddRowH,
              onCellDoubleClicked: onCellDoubleClick,
            }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={columns.grid2}
            rowData={dataSources.grid2}
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "상세정보",
            }}
            events={{
              onBtnAddClick: onAddRow,
              onBtnDeleteClick: onDeleteRow,
              onBeforeAddRow: onBeforeAddRowL,
              onCellValueChanged: onCellValueChangedL,
            }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_TRA_IBL_REG_003;
